const authentication = require('../../../react-azure-adb2c2').default;






export const share_check = (values: any) => {
  // let url = `http://localhost:5000/v1/sms/share/check`;
  let url = process.env.REACT_APP_API_PM_URL + `/v1/sms/share/check`;
  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};



export const share_list = (values: any) => {
  // let url = `http://localhost:5000/v1/sms/share/list`;
  let url = process.env.REACT_APP_API_PM_URL + `/v1/sms/share/list`;
  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};


